import { common } from './common';
import { admin } from './admin';

export const LocaleHelpers = {
	common,
	admin,
};
